import SyncTypeRadioGroup, {
  SyncTypeOption,
} from 'components/SyncTypeRadioGroup';

const SYNC_TYPE_OPTIONS: SyncTypeOption[] = [
  { value: 'crm', label: 'Create in CRM' },
  { value: 'crono', label: 'Only in Crono' },
];

export interface SyncTypePickerProps {
  createInCrm: boolean;
  onChange: (createInCrm: boolean) => void;
}

/** "Create in CRM" / "Only in Crono" choice of a creation form. */
const SyncTypePicker = ({ createInCrm, onChange }: SyncTypePickerProps) => (
  <SyncTypeRadioGroup
    aria-label="Where to create"
    options={SYNC_TYPE_OPTIONS}
    value={createInCrm ? 'crm' : 'crono'}
    onChange={(next) => onChange(next === 'crm')}
  />
);

export default SyncTypePicker;
